import * as i0 from '@angular/core';
import { Directive } from '@angular/core';
import { provideHostControl } from 'di-controls/tokens';
import { DIControl } from 'di-controls/controls';
let DIControlSilencerDirective = /*#__PURE__*/(() => {
  class DIControlSilencerDirective extends DIControl {
    constructor() {
      super();
    }
    registerControl() {
      // do nothing
    }
    unregisterControl() {
      // do nothing
    }
    static ɵfac = function DIControlSilencerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DIControlSilencerDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DIControlSilencerDirective,
      selectors: [["", "diControlSilencer", ""]],
      features: [i0.ɵɵProvidersFeature([provideHostControl(DIControlSilencerDirective)]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return DIControlSilencerDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DIControlSilencerDirective };
